<template>
  <div class="recharge-management">
    <el-form :inline="true" :model="form">
      <el-form-item label="经营者"><el-input v-model="form.managerName" /></el-form-item>
      <el-form-item label="手机号"><el-input v-model="form.managerPhone" /></el-form-item>
      <!-- <el-form-item label="经营者编码"><el-input v-model="form.managerCode" /></el-form-item> -->
      <el-form-item label="充值时间">
        <el-date-picker
          v-model="form.searchTimeVal"
          type="datetimerange"
          :unlink-panels="true"
          range-separator="~"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          format="YYYY-MM-DD HH:mm:ss"
          value-format="YYYY-MM-DD HH:mm:ss"
        />
      </el-form-item>
      <el-form-item><el-button @click="search" type="primary">查询</el-button></el-form-item>
    </el-form>
    <div>
      <div style="margin-bottom: 8px;">累计充值金额: <span class="highlight">{{toFixed(total.rechargeTotal) || 0}}</span>元, 累计消耗服务费: <span class="highlight">{{toFixed(total.costTotal) || 0}}</span>元</div>
      <!-- <el-button>充值</el-button> -->
    </div>
    <el-table v-bind="tableOptions" :data="tableData" ref="table">
      <el-table-column label="充值订单号" prop="rechargeCode" width="200px" />
      <el-table-column label="经营者" prop="managerName" />
      <el-table-column label="手机号" prop="managerPhone" width="120px" />
      <el-table-column label="房源数" prop="roomCount" />
      <el-table-column label="充值金额" prop="amount">
        <template v-slot="scope">
          <span>{{toFixed(scope.row.amount) || 0}}</span>
        </template>
      </el-table-column>
      <el-table-column label="累计充值金额" prop="rechargeTotal" width="120px">
        <template v-slot="scope">
          <span>{{toFixed(scope.row.rechargeTotal) || 0}}</span>
        </template>
      </el-table-column>
      <el-table-column label="余额" prop="balance">
        <template v-slot="scope">
          <span>{{toFixed(scope.row.balance) || 0}}</span>
        </template>
      </el-table-column>
      <el-table-column label="收款账户" prop="accountName" width="120px" />
      <el-table-column label="充值时间" prop="rechargeTime" width="180px" />
      <el-table-column label="备注" prop="remark" />
    </el-table>
    <RPagination :pagination="pagination" @current-change="handlePageChange" />
  </div>
</template>

<script>
import RPagination from '@/components/common/RPagination'
import { mapActions } from "vuex";
export default {
  name: "RechargeManagement",
  components: { RPagination },
  data(){
    return {
      pagination: {
        total: 0,
        pageNumber: 1,
        pageSize: 20,
      },
      tableOptions: {
        height: "100%",
      },
      tableData: [],
      form: {
        managerName: "",
        managerPhone: "",
        managerCode: "",
        searchTimeVal: "",
      },
      total: {
        rechargeTotal: "",
        costTotal: ""
      }
    }
  },
  methods: {
    ...mapActions(["fetchData"]),
    toFixed(value){
      return new Number(value).toFixed(2);
    },
    setTableHeight() {
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$refs.table) {
            const top = this.$refs.table.$el.getBoundingClientRect().top
            const height = document.body.clientHeight - top - 60
            this.tableOptions.height = height
          }
        }, 100)
      })
    },
    search(){
      this.fetchData({
        url: '充值记录',
        method: 'get',
        params: {
          managerName: this.form.managerName, // 经营者名称
          managerPhone: this.form.managerPhone, // 经营者手机号
          managerCode: this.form.managerCode, // 经营者编码
          rechargeTimeStart: this.form.searchTimeVal && this.form.searchTimeVal[0], // 充值时间-开始
          rechargeTimeEnd: this.form.searchTimeVal && this.form.searchTimeVal[1], // 充值时间-结束
          pageNumber: this.pagination.pageNumber,
          pageSize: this.pagination.pageSize,
          result: 2,
        }
      }).then(res => {
        this.tableData = res.data;
        this.pagination.total = res.rowCount;
      });
      this.getTotal();
    },
    handlePageChange(index, size) {
      this.pagination.pageNumber = index;
      this.pagination.pageSize = size;
      this.search();
    },
    getTotal(){
      this.fetchData({
        url: '统计',
        method: 'get',
        params: {
          managerName: this.form.managerName, // 经营者名称
          managerPhone: this.form.managerPhone, // 经营者手机号
          managerCode: this.form.managerCode, // 经营者编码
          createDateStart: this.form.searchTimeVal && this.form.searchTimeVal[0],
          createDateEnd: this.form.searchTimeVal && this.form.searchTimeVal[1],
        }
      }).then(res => this.total = res);
    }
  },
  created(){
    this.search();
  },
  mounted() {
    this.setTableHeight()
    window.addEventListener('resize', this.setTableHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setTableHeight)
  },
}
</script>

<style lang="less" scoped>
.recharge-management{
  .highlight{
    color: red;
  }
}
</style>